export enum EntityType {
  SOLE_PROPRIETOR = 'SOLE_PROPRIETOR', // Sole Proprietor
  GENERAL_PARTNERSHIP = 'GENERAL_PARTNERSHIP', // General Partnership
  C_CORP = 'C_CORP', // C-Corp
  S_CORP = 'S_CORP', // S-Corp
  LLC = 'LLC', // Limited Liability Company
  LLC_DISREGARDED_ENTITY = 'LLC_DISREGARDED_ENTITY', // Limited Liability Company filing as a disregarded entity (single member)
  LLC_S_CORP = 'LLC_S_CORP', // Limited Liability Company filing taxes as an S Corporation
  PROFESSIONAL_LLC = 'PROFESSIONAL_LLC', // Professional Limited Liability Company
  PROFESSIONAL_ASSOC_S_CORP = 'PROFESSIONAL_ASSOC_S_CORP', // Professional Association filing as an S Corporation
}
